exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sendSMS .values-list__element{padding-top:0;padding-bottom:0;padding-left:10px;margin-top:0;border-bottom:1px solid #d3d3d3;display:flex;justify-content:space-between;line-height:32px}#sendSMS :not(.v-icon){font-size:12px}#sendSMS #values-list>li:nth-child(2)>div:nth-child(3)>div{max-height:32px}#sendSMS .no-number-background{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1757b3c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/analysis/modals/SendSMS.vue
// module id = 1771
// module chunks = 0